import styles from './FormFileField.module.css';

function FormFileField({ error, label, value, onChange, hasBorder, children, ...props }) {
    let placeholder = props.placeholder;
    let wrapper_class = styles.wrapper;
     if (value) {
        if (value.name) {
            placeholder = value.name;
        }
        // If it's a string (edit mode with file path), extract and show the file name
        else {
            const extractExtension = (filePath) => {
                const fileNameMatch = filePath.match(/(?:[^/\\]+\/)*([^/\\]+\.\w+)$/);
                if (fileNameMatch) {
                    const fileName = fileNameMatch[1];
                    const ext = fileName.split('.').pop();
                    return ext; // Returns the extension, e.g., "pdf"
                }
                return ''; // If no match found, return an empty string
            };
            const extractName = (filePath) => {
                const extension = extractExtension(filePath);
                const nameMatch = filePath.match(/name:([^-.]+)/);
                return nameMatch ? nameMatch[1] + "." + extension : '';
            };

            const fileName = extractName(value)
            if (fileName.length > 0) {
                placeholder = fileName;
            } else {
                placeholder = value;
            }
        }

    }

    if (error) {
        wrapper_class += ' ' + styles.wrapper_error;
    }

    if (hasBorder) {
        wrapper_class += ' ' + styles.hasBorder;
    }

    const handleChange = (e) => {
        onChange({
            target: {
                name: props.name,
                value: e.target.files ? e.target.files[0] : null,
            }
        });
    };

    return (
        <div className={styles.field}>
            {label && <label htmlFor={props.name}>{label}</label>}
            <div className={wrapper_class}>
                <span>{placeholder}</span>
                <input onChange={handleChange} {...props} />
            </div>
            {error && <p className={styles.error}>{error}</p>}
        </div>
    );
}

export default FormFileField;